var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtari(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1582 1263",
    width: 1582,
    height: 1263,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ATA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2828",
    fillRule: "evenodd",
    className: "s0",
    d: "m0.7 1070.6l11.4-1.9c35.6-6 88.5-21.9 124.5-37.2c114.3-48.9 215.9-139.2 300.6-267.3c22.9-34.8 46-87.4 62.7-143.4c41.4-138.7 64.6-340 64.8-558.8v-61.9h96.5l-1.2 146.8c-2.3 321.9-11.1 457-37.3 573.2c-21.9 98.1-65.3 191.9-121.3 261.9c-18.6 23.1-72.7 77.7-98.3 98.7c-99.7 82.3-210.1 139.9-321.1 167.7c-24.7 6.3-66.8 13.7-76.9 13.7h-4.4zm698.6-1070.5h183.5v1262h-183.5zm853.6 1259.2c-176-26.7-377.8-149.8-487.5-297c-46.5-62.4-86.8-154.4-106.7-243.7c-26.3-118.4-37-295.4-37.1-617.2v-101.3h95.9v68.6c0 312.7 46.8 570.5 125.6 693.2c45.6 70.9 108 140.9 169.4 190.1c73.4 58.7 166.9 101.1 257.7 116.7l11.2 1.9v191.5l-6.3-0.2c-3.3-0.1-13.4-1.3-22.2-2.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtari);
export default __webpack_public_path__ + "static/media/Atari.1c25eb676af8ff0506d7614351432fca.svg";
export { ForwardRef as ReactComponent };